import axios from "axios";
import { isEmpty, trim } from "lodash";
import moment from "moment";
import React, { useEffect, useReducer, useState } from "react";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import { BsArrowLeft } from "react-icons/bs";
import { FaPen } from "react-icons/fa";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { MdCancel } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Components/Global/Loader";
import DashboardLayouts from "../../Components/Layout/DashboardLayouts";
import useAuthentication from "../../hooks/useAuthentication";
import useAxiosFetch from "../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../hooks/useMultipleImgUpload";
import useSearchListPagination from "../../hooks/useSearchListPagination";
import DummyImg from "../../Public/Images/568165.png";

function Requestlist({ allowedRoles }) {




  



  const { allowLoading } = useAuthentication(allowedRoles);

  
  const initialState={
    task_title:"",
    task_category:"",
    sub_task_category:"",
    issue_date:"",
    receiver:[],
    description:"",
    allReceivers:[]
    }

    

    const updateStateFunc=(state, action)=>{
      switch(action.type){
        case "input":
          return {...state, [action.payload.target.name]: action.payload.target.value} ;
          case "checkbox":
            return {...state, receiver: action.payload.target.checked ?    [...state.receiver,action.item?.user_id] : action.item?.role_id ==1 ?  state.receiver.map(r=>r) : state.receiver.filter(r=>r!==action.item?.user_id)} ;
        
        case "select":
          return {...state, [action.payload.target.name]: action.payload.target.value} ;
        case "date":
          return {...state, issue_date: action.payload} ;
        case "receiver_all":
          return {...state, allReceivers: action.payload} ;
        case "update_all_from_api":
          return {...state, ...action.payload ,issue_date:action.payload?.issue_date ?  new Date(action.payload?.issue_date ) : new Date() ,   receiver:action.payload?.receiverId?.map(r=>r?.receiverId) };

          default: return state;
      }
    }
    
    const [stateData,dispatch]=useReducer(updateStateFunc,initialState)











    // api api from global hook 

  const { axiosFetch} = useAxiosFetch();

  
  const {
    setisKeyPress,
    Count,
    setsearchKey,
    searchKey,
    setRecord,
    record,
    setPages,
    pages,
    totallength,
    paginationLoading,
    handleNextbtn,
    handlePrevbtn,
    PageShowFunc,
    SearchListApi,
    allData,
    responseData,
  } = useSearchListPagination();



  const [errorMessage, setErrorMessage] = useState("");

  const [request_id, setrequest_id] = useState("");
 


  

  const route = useNavigate();


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [loading, setLoading] = useState(false);

 
  const {
    task_title,
    task_category,
    issue_date,
    description,
    request_image,
    sub_task_category,
  } = stateData;
  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();



 




  const validation = (values) => {
    const errors = {};


    if (!task_title || !trim(task_title)) {
      errors.task_title = "Please enter your Task title.";
    }

    if (stateData.receiver?.length === 0) {
      errors.receiverslIsts = "Please choose at least one Receiver.";
    }
    return errors;
  };

 
 
  const TaskFunc = (e) => {
    e.preventDefault();

    const Valid = validation();
    setErrorMessage(Valid);

    if (
      Object.keys(Valid).length == 0 &&
      stateData.receiver?.length > 0 &&
      selectedImages.length < 11
    ) {
    
      setLoading(true);
      setErrorMessage();
      const filterImages = selectedImages.filter(
        (file) => !file.url.includes("blob:")
      );
      const removeUrlTag = filterImages.map((img) => img.url);
      if (selectedImages.length === 0) {
        taskFuncWithImg([]);
      } else if (
        selectedImages.filter((img) => img.file !== undefined).length == 0
      ) {
        taskFuncWithImg(removeUrlTag);
      } else {
        uploadToserver("request_image",setLoading)
          .then((res) => {
            setImgLinks(res?.data?.links);
            taskFuncWithImg([...res?.data?.links, ...removeUrlTag]);
          
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    }
  };

  const taskFuncWithImg = (imagesss) => {
  
    const {RequestAssigns,allReceivers,receiverId,...rest}=stateData

 
    axios
      .post(`request/update/${request_id}`, {...rest,request_image: JSON.stringify(imagesss),})
      .then(function (response) {
        if (response.status === 200) {
          SearchListApi("request");
          handleClose(false);
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

 




  const handleUpdateRequest = (id) => {

    axiosFetch({
      axiosInstance: axios,
      method: 'GET',
      url: `/request/show/${id}`,
   
  }).then(function (response) {
      handleShow();
   

      setSelectedImages(response.data?.request_image ?
        JSON.parse(response.data?.request_image)?.map(img=>({url:img})) : [])
 

        dispatch({type: "update_all_from_api", payload: response.data})
    });
  };

useEffect(()=>{

  
  axiosFetch({
    axiosInstance: axios,
    method: 'POST',
    url: "request/receiver/list",
 
}).then((res) => {

  dispatch({type: "receiver_all", payload: res.data?.result?.rows})

  
})
},[])

useEffect(() => {
  
  SearchListApi("request");

}, [searchKey, record, pages]);


  return (
    <>
      <DashboardLayouts>
        { allowLoading && <Loader />}

        <div className="breadcrumb row justify-content-between align-items-center">
          <div className="d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
            <Link
              to="/tenantdashboard"
              className="d-flex align-items-center back-link"
            >
              <BsArrowLeft className="me-2 m-0 back-arrow" color="black" />
              <i className="icon-dashboard"></i>
              <h3 className="mb-0 fw-normal"> Tenant Dashboard</h3>
            </Link>
          </div>

          <div className="col-auto btn-responsive"></div>
        </div>
        {/* ----- Body Content ---- */}
        <div className="list-data">
          <h1 className="heading-text mb-4">View All Request</h1>
          {/* --- Data filter --- */}
          <div className="data-filters d-flex justify-content-between align-items-center mb-4">
            <div className="page-records d-flex align-items-center">
              <form action="" className="number">
                <select
                  className="number-box"
                  value={record}
                  name="record"
                  onChange={(event) => {
                    setRecord(event.target.value);
                    setPages(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                </select>
              </form>
              <h3 className="mb-0 ms-2 d-none d-sm-block">Records Per Page</h3>
            </div>

            {/* <div className="form search-bar1">
              <input
                type="search"
                className="form-control search-new"
                placeholder="search request"
                aria-label="search"
                aria-describedby="search"
                name="workerSearch"
                value={requestSearch}
                onChange={(e) => setSearchrequest(e.target.value.trimStart())}
              />
              <button
                className="search-btn fa-solid fa-magnifying-glass"
                type="submit"
                onClick={(e) => SearcRequestFun(e)}
              >
                <FaSearch className="m-0  " color="#bebebe" />
              </button>
            </div> */}
          </div>
        </div>
        <div className="w-100 table-content">
          <div className="w-100 overflow-auto">
            <table className="w-100">
              <thead>
                <tr>
                  <th className="text-center">Sl No.</th>
                  <th>Task Tittle</th>
                  <th>Task Issue Date</th>
                  <th>Task Category</th>
                  <th>Task Sub Category</th>
                  <th>Task Recevier</th>
                  <th>Task Description</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {allData?.length > 0 ? (
                  allData?.map((items, i) => {
                    return (
                      <tr key={i} className={`border-b`}>
                        <td className="text-center">
                          {" "}
                          {pages > 1 ? record * (pages - 1) + i + 1 : i + 1}
                        </td>
                        <td>{items.task_title}</td>
                        <td>{moment(items.issue_date).format("L")}</td>
                        <td>{items.task_category}</td>
                        <td>{items.sub_task_category}</td>
                        <td>{items.RequestAssigns?.slice(0,2)?.map(user=>(
                          <p>{`${user?.User?.first_name} ${user?.User?.last_name}`}</p>
                        ))}</td>
                        <td>{items.description.substring(0, 30)}...</td>
                        {items.status == true ? (
                          <td style={{ color: "green" }}>Completed</td>
                        ) : items.status == false ? (
                          <td style={{ color: "blue" }}>Under Renovation</td>
                        ) : (
                          <td style={{ color: "red" }}>Pending</td>
                        )}
                        <td>
                          <ul className="table-icon d-flex">
                            <li>
                              <Link
                                to={`#`}
                                onClick={() => {
                                  setrequest_id(items.id);
                                  handleUpdateRequest(items.id);
                                }}
                              >
                                <FaPen className=" fs-6  ml-5 " color="black" />
                              </Link>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No Request List
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {totallength.length > 1 ? (
            <div className="table_bottom d-flex align-items-center justify-content-end mt-5 pageNumbers">
              <button
                onClick={handlePrevbtn}
                disabled={pages == 1 ? true : false}
              >
                <GrFormPrevious className="pagebutton" color="#bebebe" />
              </button>
              <ul className="d-flex">{allData?.length > 0 && PageShowFunc}</ul>
              <button
                onClick={handleNextbtn}
                disabled={pages == PageShowFunc.length ? true : false}
              >
                <GrFormNext className="pagebutton" color="#bebebe" />
              </button>
            </div>
          ) : null}
        </div>
        <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
        className="Raise-rq-modal-popup"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="heading-text fw-bold mb-0">Raise Request</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {true ? (
            <form action="" className="add-form add-building-area row">
              {loading ? (
                <Loader />
              ) : (
                <>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Task Title
                          </label>
                          <input
                            type="text"
                            name="task_title"
                            value={stateData?.task_title}
                            onChange={(e) =>{ 
                              dispatch({ type:"input", payload:e})
                              }}
                            className="form-control form-g1"
                            id="form-request*"
                          />

                          {errorMessage?.task_title ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.task_title}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Choose Task Category
                          </label>

                          <select
                            type="text"
                            name="task_category"
                            value={stateData?.task_category}
                            onChange={(e) =>{ 
                              dispatch({ type:"input", payload:e})
                              }}
                            className="form-control form-g1"
                            id="form-request*"
                          >
                            <option value="">Choose</option>
                            <option value="Maintenance">Maintenance</option>
                            <option value="Accounts">Accounts</option>
                            <option value="Security">Security</option>
                            <option value="Legal">Legal</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Sub Task Category
                          </label>

                          <select
                            type="text"
                            name="sub_task_category"
                            value={stateData?.sub_task_category}
                            onChange={(e) =>{ 
                              dispatch({ type:"input", payload:e})
                              }}
                            className="form-control form-g1"
                            id="form-request*"
                          >
                            {!isEmpty(stateData?.task_category) ? (
                              stateData?.task_category == "Maintenance" ? (
                                <>
                                  <option value="">Choose</option>
                                  <option value="Plumbing">Plumbing</option>
                                  <option value="Electrical">Electrical</option>
                                  <option value="Cleaning">Cleaning</option>
                                  <option value="Fire alarm/Smoke detector">
                                    Fire alarm/Smoke detector
                                  </option>
                                  <option value="Painting">Painting</option>
                                  <option value="General work">
                                    General work
                                  </option>
                                </>
                              ) : (
                                <>
                                  <option value="">Choose</option>
                                  <option value="Option-1">Option-1</option>
                                  <option value="Option-2">Option-2</option>
                                  <option value="Option-3">Option-3</option>
                                </>
                              )
                            ) : (
                              <option value="null">Choose sub category</option>
                            )}
                          </select>
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Issue Date
                          </label>
                          {/* <input
                      type="date"
                      name="issue_date"
                      value={issue_date}
                      onChange={(e) => }
                      className="form-control form-g1"
                      id="form-request*"
                    // placeholder="Country"
                    /> */}

                          <DatePicker


                            selected={stateData?.issue_date}
                            onChange={(date) => {
                              dispatch({ type:"date", payload:date})
                            }}
                            minDate={new Date()}
                            required
                            className="form-control form-g1"
                          />
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-3">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Choose Receivers :
                          </label>
                        </div>
                      </div>
                      <div className="col-xl-12 col-md-12 mb-3">
                        <div className="form-group">
                          {stateData?.allReceivers?.map((item, i) => {
                            return (
                              <label className="pr-3">
                                <input
                                  type="checkbox"
                                  name="receivers"
                                  value={item?.user_id}
                                  className="me-1"
                                  checked={stateData?.receiver?.includes(item?.user_id)}
                              
                                  onChange={(e) =>{ 
                                    dispatch({ type:"checkbox", payload:e,item:item})
                                    }}

                                />

{item.User?.first_name} {item.User?.last_name} {item?.role_id == 3 ? "(Tenant)" : "" || item?.role_id == 2 ? "(Manager)" : "" || item?.role_id == 1 ? "(Owner)" : "" || item?.role_id == 4 ? "(Worker)" : "" || item?.role_id == 5 ? "(Partner)" : "" || item?.role_id == 6 ? "(Accountant)" : ""}
                            
                              </label>
                            );
                          })}

                          {errorMessage?.managerName ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.managerName}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-12">
                        <div className="form-group">
                          <label htmlFor="" className="form-lbl">
                            Description
                          </label>
                          <textarea
                            className="form-control form-g1"
                            type="text"
                            name="description"

                            value={stateData?.description}
                            onChange={(e) =>{ 
                              dispatch({ type:"input", payload:e})
                            }}
                            
                            id="form-request*"
                            placeholder="Description"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 mt-md-4 mt-lg-0">
                    <div className="d-flex align-items-center justify-content-center justify-content-lg-end">
                      <div className="area-hide add-building-img">
                        <div className="image-area d-flex align-items-center justify-content-center position-relative">
                          {selectedImages.length > 0 ? (
                            <img
                              id="show-image"
                              src={
                                defaultImg ? defaultImg : selectedImages[0]?.url
                              }
                              alt=""
                            />
                          ) : (
                            <img id="show-image" src={DummyImg} />
                          )}

                          <div className="img-upload">
                            <label
                              htmlFor="request_image"
                              className="img-upload-lbl"
                            >
                              <FaPen className="edit-pen" color="black" />
                            </label>

                            <input
                              type="file"
                              className="form-control d-none"
                              id="request_image"
                              name="request_image"
                              multiple
                              accept="image/png, image/gif, image/jpeg"
                              // onChange={(e) => onFileUpload(e)}
                              onChange={onSelectFile}
                            />
                          </div>
                        </div>
                        <div className="add-images d-flex ">
                          {selectedImages?.map((url, index) => {
                            return (
                              <div className="img-sec" key={index}>
                                <img
                                  id="show-image"
                                  src={url?.url}
                                  alt=""
                                  onClick={() => handleDefaultImage(url?.url)}
                                  // onClick={() => onClickImages(url?.url)}
                                />
                                <MdCancel
                                  className="image_cancel"
                                  onClick={() => {
                                    deleteHandler(url?.url);
                                  
                                  }}
                                />
                              </div>
                            );
                          })}
                         

                          <div className="img-sec d-flex align-items-center justify-content-center form-control">
                            <label
                              htmlFor="request_image"
                              className="img-upload-lbl img-add-btn fs-4"
                            >
                              +
                            </label>
                          </div>
                          {selectedImages && selectedImages.length > 10 && (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              You can't upload more than 10 images! <br />
                              <span>
                                please delete{" "}
                                <b> {selectedImages.length - 10} </b> of them{" "}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-100">
                    <div className="d-flex mt-md-5">
                      {/* <button
                    className="skip-btn"
                    onClick={() => {
                      setShow(false);
                    }}
                  >
                    Cancel
                  </button> */}
                      <button
                        className="btn btn-primary"
                        onClick={(e) => {
                          TaskFunc(e);
                        }}
                      >
                        Request now
                      </button>
                    </div>
                  </div>
                </>
              )}
            </form>
          ) : (
            <p className="text-center text-danger">Please active the Tenant</p>
          )}
        </Modal.Body>
      </Modal>
      </DashboardLayouts>
    </>
  );
}

export default Requestlist;
